import { css } from "lit";
export default css `

    pb33f-timeline-item {
        width: 100%;
        margin-bottom: 20px;
    }

    .start {
        position: relative;
        width: 100%;
        height: 20px;
    }
    

    .ball-start {
        width: 15px;
        height: 15px;
        border-radius: 10px;
        background-color: var(--bars-and-borders);
        position: absolute;
        left: 33px;
        top: 5px;
        z-index: 10;
    }
    
    .skinny {
        left: 7px!important;
    }

    .ball-end {
        width: 15px;
        height: 15px;
        border-radius: 10px;
        background-color: var(--bars-and-borders);
        position: absolute;
        left: 33px;
        top: 0;
        z-index: 10;
        margin-bottom: 20px;
    }

    .end {
        position: relative;
        width: 100%;
        height: 20px;
    }

    @media only screen and (max-width: 1000px) {
        .ball-start {
            left: -5px;
        }

        .ball-end {
            left: -5px;

        }
    }
`;
